// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountSaveModel {
    static getAttributeTypeMap() {
        return AccountSaveModel.attributeTypeMap;
    }
}
AccountSaveModel.discriminator = undefined;
AccountSaveModel.additionalProperties = false;
AccountSaveModel.attributeTypeMap = [
    {
        "name": "accountType",
        "baseName": "accountType",
        "type": "AccountType"
    },
    {
        "name": "accountStatus",
        "baseName": "accountStatus",
        "type": "AccountStatus"
    },
    {
        "name": "partyId",
        "baseName": "partyId",
        "type": "number"
    },
    {
        "name": "securePartyId",
        "baseName": "securePartyId",
        "type": "string"
    },
    {
        "name": "assignedUser",
        "baseName": "assignedUser",
        "type": "number"
    },
    {
        "name": "payors",
        "baseName": "payors",
        "type": ""
    },
    {
        "name": "prescribers",
        "baseName": "prescribers",
        "type": ""
    },
    {
        "name": "sites",
        "baseName": "sites",
        "type": ""
    },
    {
        "name": "pharmacies",
        "baseName": "pharmacies",
        "type": ""
    },
    {
        "name": "documents",
        "baseName": "documents",
        "type": ""
    },
    {
        "name": "notes",
        "baseName": "notes",
        "type": ""
    },
    {
        "name": "tasks",
        "baseName": "tasks",
        "type": ""
    },
    {
        "name": "voicemailOptInStatus",
        "baseName": "voicemailOptInStatus",
        "type": ""
    },
    {
        "name": "assignmentOfBenefitFlag",
        "baseName": "assignmentOfBenefitFlag",
        "type": "boolean"
    },
    {
        "name": "isIneligibleForMailInClaims",
        "baseName": "isIneligibleForMailInClaims",
        "type": "boolean"
    },
    {
        "name": "allowAutoReenroll",
        "baseName": "allowAutoReenroll",
        "type": "boolean"
    },
];
//# sourceMappingURL=accountSaveModel.js.map